export default "__VITE_ASSET__5169cbe1__"